









import { Component, Vue } from 'vue-property-decorator'
import FormWizard from './components/formwizard/FormWizard.vue'
import 'es6-promise/auto'
import { store } from './store/store'
// import Vue from 'vue'
import AppLogger from './services/AppLogger'

if (localStorage.getItem('sandbox') === 'undefined') {
    throw new Error('chyba konfigurace (chybí sandbox)')
}
if (localStorage.getItem('accessToken') === 'undefined') {
    throw new Error('chyba konfigurace (chybí accessToken)')
}
if (localStorage.getItem('refreshToken') === 'undefined') {
    throw new Error('chyba konfigurace (chybí refreshToken)')
}
if (localStorage.getItem('crm') === 'undefined') {
    throw new Error('chyba konfigurace (chybí crm)')
}
console.log('accessToken', localStorage.getItem('accessToken'))
console.log('refreshToken', localStorage.getItem('refreshToken'))
console.log('sandbox', localStorage.getItem('sandbox'))
console.log('crm', localStorage.getItem('crm'))

store.commit('config/setSandbox', localStorage.getItem('sandbox'))
// store.commit('config/setAccessToken', localStorage.getItem('accessToken'))
// store.commit('config/setRefreshToken', localStorage.getItem('refreshToken'))
store.commit('config/setCrm', localStorage.getItem('crm'))

// Bootstrap plugin
import BootstrapVue from 'bootstrap-vue'
Vue.use(BootstrapVue)

// Register a global custom directive called `v-focus`
Vue.directive('focus', {
    // When the bound element is inserted into the DOM...
    inserted: function(el) {
        // Focus the element
        el.focus()
    },
})

const logger = new AppLogger()

Vue.config.errorHandler = (err, vm, info) => {
    logger.logToServer({ err, vm, info })
}

window.onerror = function(message, source, lineno, colno, error) {
    logger.logToServer({ message, source, lineno, colno, error })
}

const plugin = document.createElement('script')
if (localStorage.getItem('sandbox')) {
    plugin.setAttribute(
        'src',
        'https://gw.sandbox.gopay.com/gp-gw/js/embed.js'
    )
} else {
    plugin.setAttribute(
        'src',
        'https://gate.gopay.cz/gp-gw/js/embed.js'
    )
}
plugin.async = true
document.head.appendChild(plugin)


@Component({
    store,
    components: {
        FormWizard,
    },
})
export default class App extends Vue {
    get isSandbox() {
        return localStorage.getItem('sandbox') == '1'
    }
}
